export default {
  heading: "啟動教城帳戶",
  intro: "請建立密碼以啟動您新登記的教城帳戶{id}。",
  submitBtn: "確定",
  resetBtn: "重設",
  closeBtn: "關閉",
  completed:
    "您已成功啟動戶口。 ",
  recordNotFound: "很抱歉，您輸入的網址有誤。<br>請檢查網址連結是否正確。如需協助，請電郵至 <a href=\"mailto:support{'@'}edcity.hk\" target=\"_top\">support{'@'}edcity.hk</a>。",
  backToHome: "返回主頁",
  hasActivated: "您已利用此連結啟動教育城戶口。這連結已失效。",
  expired: "這連結已超時失效。",
  userNotFound: "系統找不到您的帳戶，請聯繫您的學校管理員檢查帳戶。",
};